var render = function render(){var _vm=this,_c=_vm._self._c;return _c('generic-page',[_c('back-to-dashboard'),_c('div',{staticClass:"d-flex align-items-center justify-content-between"},[_c('h5',[_vm._v(" "+_vm._s(_vm.$t("My Money"))+" ")])]),(_vm.withdraw)?_c('div',[_c('withdraw-pending')],1):_vm._e(),_c('earnings-stats'),_c('earnings-navigation',{staticClass:"mt-3"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }